// extracted by mini-css-extract-plugin
export var pillWrapper = "_nn-0";
export var showOverflow = "_nn-1";